import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../component/sidebar";
import { Box, Grid, Typography } from "@mui/material";
import Header from "../../component/header";
import BasicTable from "../tables/BasicTable";
import {
  useGetMissionsQuery,
  useUpdateMissionMutation,
  useDeleteMissionMutation,
  useAddMissionMutation,
} from "../../../../services/missionSlice";

import MissionAddButton from "./missionAddButton";

const DashboardMissions = () => {
  return (
    <Grid container className="dashboard-full-background">
      <Grid item xs={2} spacing={4}>
        <Sidebar />
      </Grid>
      <Grid item xs={10}>
        <Header />
        <DashboardMissionsPages />
      </Grid>
    </Grid>
  );
};

const DashboardMissionsPages = () => {
  const { data, isLoading, isSuccess, isError, error } =
    useGetMissionsQuery("getMissions");

  const [deleteMission] = useDeleteMissionMutation();

  const deleteConfirm = (e, id) => {
    e.preventDefault();
    deleteMission({ id });
  };

  let headers = [];
  let tableData = [];
  let content;
  if (isLoading) {
    content = <p>"Loading..."</p>;
  } else if (isSuccess) {
    headers = [
      "Mission Name",
      "Active"
    ];
    tableData = [];
    data.ids.forEach((key) => {
      tableData.push({
        "Mission Name": data.entities[key].mission_name,
        "Active": data.entities[key].is_active,
        id: data.entities[key].id,
      });
    });
  }
  return (
    <>
      <Box className="table-design-background">
        <Grid container>
          <Grid item xs={6}>
            <Typography className="dashboard-home-page-text">
              Mission Lists
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Link to="/dashboard/new/missions">
              <MissionAddButton />
            </Link>
          </Grid>
        </Grid>
        <Box style={{ padding: "1rem" }}>
          <BasicTable
            headers={headers}
            data={tableData}
            isDelete={true}
            deleteColor={"#f50057"}
            isEdit={true}
            editColor={"#3f51b5"}
            addColor={""}
            tableName={"missions"}
            deleteConfirm={deleteConfirm}
            activeSign={['Active']}
          />
        </Box>
      </Box>
    </>
  );
};
export default DashboardMissions;
